<script setup>
import RoamingPlan from './components/roamingPlan/roamingPlan.vue';
import Search from './components/RoamingSearch/search.vue';
import { __ } from '@/utils';
import { ref, onMounted } from 'vue';

const packages = ref('');

const handlePlanSubmit = (plan) => {

    localStorage.removeItem('formRoaming');
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');

    localStorage.setItem('formRoaming', JSON.stringify({
        ...plan,
    }));

    window.location.replace('/roaming-steps');
}

const handleSearchedPlans = (plans) => {
    packages.value = plans.response;
}

onMounted(() => {
    const roamingPlansElement = document.querySelector('.vue-js-roaming');
    
    if (roamingPlansElement) {
        packages.value = JSON.parse(roamingPlansElement.getAttribute('data-roaming-plans'));
        packages.value = packages.value.sort((a, b) => a.price - b.price);
    }
});

const roaming_sms_pricelist = ref(roamingRates.roaming_call_sms_pricelist)
</script>
 
<template>
    <Search
        @searchedPlans="handleSearchedPlans"
    >
        <div class="plans-featured">
            <div class="no-plans-found"  v-if="!packages?.[0]?.product_id">
                {{ __('no available packages') }}
            </div>
            <div class="plans__grid plans__grid--limit-width"> 
                <RoamingPlan
                    v-if="packages?.[0]?.product_id"
                    v-for="packageItem of packages"
                    :key="packageItem?.code" 
                    :plan="packageItem"
                    :packages="packages"
                    @searchedPlans="handleSearchedPlans"
                > 
                    <template #popup_body>
                        <div class="popup__pdf-link">
                            <a href="https://xphone.co.il/roaming_pricelist_without_package" target="_blank" class="tile__additional-link link-arrow gradient hidden-xs">{{ __('Rates for use abroad beyond the package') }}</a>
                            <a :href="roaming_sms_pricelist" v-if="roaming_sms_pricelist" target="_blank" class="tile__additional-link link-arrow gradient hidden-lg hidden-md hidden-sm">{{ __('Rates for use abroad beyond the package') }}</a>
                        </div>
                    </template>
                    <template #actions="plan">
                        <div class="tile__actions">
                            <form
                                class="js-plan-submit"
                                action="#"
                                method="POST"
                                onsubmit=""
                            >
                                <input
                                    type="hidden"
                                    name="plan_id"
                                    :value="plan.product_id"
                                />
                                <button
                                    type="submit"
                                    class="btn btn--black btn--arrows btn--fullwidth"
                                    @click.prevent="handlePlanSubmit(plan)"
                                >
                                    לרכישה
                                </button>
                            </form>
                        </div>
                    </template>
                </RoamingPlan>
                
            </div><!-- /.plans__grid -->
        </div>
    </Search>
        
</template>